var Cache = require('ttl');
var cache = new Cache({
  ttl: 10 * 5000,
  capacity: 300
});
export default cache;